import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import type { Maybe } from '@/lib/types';
import { theme } from '@/theme';

import { getImageAndBackgroundStyles } from '../commonStyles.styles';

export const Header = styled(Box)<{
  $backgroundColorOpacity: Maybe<string>;
  $noBgImage?: boolean;
  backgroundColor: Maybe<string>;
  backgroundImage: Maybe<string>;
}>`
  padding: ${({ theme }) => theme.spacing(1, 0)};

  height: 375px;
  isolation: isolate;
  position: relative;

  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background-repeat: no-repeat;
      background-size: cover;
      background-position: bottom 0 center;

      ${theme.media.md.up} {
        background-position: bottom 0 center;
      }
    `}

  ${({ $backgroundColorOpacity, backgroundColor, backgroundImage }) =>
    getImageAndBackgroundStyles(
      $backgroundColorOpacity,
      backgroundColor,
      backgroundImage,
    )} 

  ${theme.media.sm.down} {
    height: ${({ $noBgImage }) => ($noBgImage ? '160px' : '221px')};
  }

  ${theme.media.md.up} {
    height: ${({ $noBgImage }) => ($noBgImage ? '160px' : '304px')};
  }
`;

export const Heading = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  min-width: 300px;
  width: 100%;

  ${({ theme }) => css`
    ${theme.media.sm.up} {
      transform: translate(-50%, -35%);
    }
    ${theme.media.md.up} {
      margin-bottom: -${theme.spacing(2)};
    }
  `}
`;

export const SubheadingCapitalized = styled.h2`
  font-size: 1.3em;
  text-transform: uppercase;
  max-width: 835px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.5em;
  margin-bottom: 0;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
  `}
`;

export const SubheadingLowercase = styled.h2`
  font-size: 1.3em;
  max-width: 835px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.5em;
  margin-bottom: 1em;
  ${({ theme }) => css`
    font-family: ${theme.fontFamilies.italianPlate};
  `}
`;

export const MediaContainer = styled(Box)<{
  $noBgImage?: boolean;
  backgroundImage: Maybe<string>;
}>`
  height: 375px;
  width: 100%;
  position: relative;

  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background-image: url(${backgroundImage});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: bottom 0 center;

      ${theme.media.md.up} {
        background-position: bottom 0 center;
      }
    `}

  ${theme.media.sm.down} {
    height: ${({ $noBgImage }) => ($noBgImage ? '160px' : '221px')};
  }

  ${theme.media.md.up} {
    height: ${({ $noBgImage }) => ($noBgImage ? '160px' : '304px')};
  }
`;

export const TextBelowContainer = styled(Box)<{
  backgroundColor: Maybe<string>;
  backgroundColorOpacity: Maybe<string>;
}>`
  padding: ${({ theme }) => theme.spacing(2, 0)};
  position: relative;
  text-align: center;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}

  ${({ theme }) => css`
    ${theme.media.md.up} {
      padding: ${theme.spacing(3, 0)};
      min-height: 220px;
    }
  `}
`;

// This allows us to handle the case where we have 2 instances of Hero listing type
//  (version for mobile / desktop) and we don't want to display duplicate filters
export const FiltersVisibilityWrapper = styled.div<{
  $visibleInDesktop?: boolean | null;
  $visibleInMobile?: boolean | null;
}>`
  ${({ $visibleInDesktop, $visibleInMobile, theme }) => css`
    ${$visibleInDesktop === false &&
    css`
      ${theme.media.md.up} {
        display: none;
      }
    `}
    ${$visibleInMobile === false &&
    css`
      ${theme.media.md.down} {
        display: none;
      }
    `}
  `};
`;
